<template>
  <div class="m-auto w-full max-w-lg overflow-hidden">
    <div class="flex items-center justify-center p-2">
      <div class="mx-1 flex w-20 flex-col rounded-md bg-white p-3 text-center">
        <UiText size="xl" class="text-primary-500">{{ days }}</UiText>
        <UiText type="small" class="text-neutral-500">{{ $t('general.days') }}</UiText>
      </div>

      <UiText size="xl" class="mx-1 text-primary-500">{{ $t('general.symbols.dots') }}</UiText>

      <div class="mx-1 flex w-20 flex-col rounded-md bg-white p-3 text-center">
        <UiText size="xl" class="text-primary-500">{{ formatTime(hours) }}</UiText>
        <UiText type="small" class="text-neutral-500">{{ $t('general.hours') }}</UiText>
      </div>

      <UiText size="xl" class="mx-1 text-primary-500">{{ $t('general.symbols.dots') }}</UiText>

      <div class="mx-1 flex w-20 flex-col rounded-md bg-white p-3 text-center">
        <UiText size="xl" class="text-primary-500">{{ formatTime(minutes) }}</UiText>
        <UiText type="small" class="text-neutral-500">{{ $t('general.minutes') }}</UiText>
      </div>

      <UiText size="xl" class="mx-1 text-primary-500">{{ $t('general.symbols.dots') }}</UiText>

      <div class="mx-1 flex w-20 flex-col rounded-md bg-white p-3 text-center">
        <UiText size="xl" class="text-primary-500">{{ formatTime(seconds) }}</UiText>
        <UiText type="small" class="text-neutral-500">{{ $t('general.seconds') }}</UiText>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PagePromoBannerCountdownProps } from '~/components/Page/types';

const props = defineProps<PagePromoBannerCountdownProps>();

const days = ref<number>(0);
const hours = ref<number>(0);
const minutes = ref<number>(0);
const seconds = ref<number>(0);
const intervalId = ref<number | null>(null);

const calculateTimeRemaining = (): void => {
  const now = new Date().getTime();
  const target = new Date(props.targetDate).getTime();
  const difference = Math.max(0, target - now);

  days.value = Math.floor(difference / (1000 * 60 * 60 * 24));
  hours.value = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  minutes.value = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  seconds.value = Math.floor((difference % (1000 * 60)) / 1000);
};

const formatTime = (time: number): string => (time < 10 ? `0${time}` : `${time}`);

onMounted(() => {
  calculateTimeRemaining();
  intervalId.value = window.setInterval(calculateTimeRemaining, 1000);
});

onUnmounted(() => {
  if (intervalId.value !== null) {
    clearInterval(intervalId.value);
  }
});
</script>
